import React from 'react';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextBox from '../../../components/textbox';
import * as userConstants from '../../admin/users/functions/constants';

const NotRegistered = ({ classes, history, me: { fetched, error, payload: me } }) => (
  <div>
    <Typography variant="h4" color="primary" gutterBottom>Politikerbasen i Trondheim kommune</Typography>
    <Typography variant="h6" color="primary" gutterBottom>
      Du er ikke registrert som politiker i Trondheim kommunes politikerbase.
    </Typography>
    <Typography variant="body1">
      Ønsker du å registrere deg som politiker?
    </Typography>
    <Typography variant="body1" gutterBottom>
      (Merk at registreringen ikke blir fullført før en administrator har godkjent søknaden din)
    </Typography>
    <br />
    <Button
      color="primary"
      variant="contained"
      onClick={() => history.push('/registrer')}
      disabled={fetched && !error && me.roles && (me.roles.includes('admin') || me.roles.includes('superadmin')) && me.active === userConstants.ENABLED}
    >
      Registrer her
    </Button>
    {fetched && !error && me.roles && (me.roles.includes('admin') || me.roles.includes('superadmin')) && me.active === userConstants.ENABLED && (
      <TextBox title="Du er registrert som administrator" className={classes.textbox}>
        <Typography variant="body1">
          <Link to="/admin">Klikk her for å gå videre til administratorsiden</Link>
        </Typography>
      </TextBox>
    )}
  </div>
);

NotRegistered.propTypes = {
  history: PropTypes.any.isRequired,
  classes: PropTypes.any.isRequired,
  me: PropTypes.object.isRequired,
};

const styles = () => ({
  textbox: {
    marginTop: '2rem',
    maxWidth: '50rem',
  },
});

const mapStateToProps = ({ me }) => ({ me });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(NotRegistered)));
